package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

import com.wintermar.inspection.core.ui.component.image.util.FileModel

data class ModalMediaState(
    val show: Boolean = false,
    val questionId: String = "",
    val files: List<FileModel> = emptyList()
)
